
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 49 51","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.62 24.664c0-6.762 5.48-12.242 12.242-12.242 6.761 0 12.242 5.48 12.242 12.242 0 6.76-5.481 12.242-12.242 12.242-6.761 0-12.242-5.481-12.242-12.242zM21.862 9.422c-8.418 0-15.242 6.824-15.242 15.242 0 8.417 6.824 15.242 15.242 15.242a15.2 15.2 0 0011.102-4.8l6.821 6.408a1.5 1.5 0 102.054-2.187l-7.035-6.608a15.17 15.17 0 002.3-8.055c0-8.418-6.824-15.242-15.242-15.242z","fill":"#131A20"}})])
          )
        }
      }
    